// extracted by mini-css-extract-plugin
export default {"mCard":"Ju-z","image":"Ku-z","imageNoBackground":"Lu-z","fullWidth":"Mu-z"};